import { ButtonERP } from "@finanedi.es/storybook"
import { DeclaracionModelo390DtoProps } from "api/DTOs/DeclaracionModelo390Dto"
import { UseFormSetValue, UseFormWatch } from "react-hook-form"
import { useTranslation } from "react-i18next"
import ActivityTemplate from "./ActivityTemplate"

const Prorrata = ({
  setValue,
  watch,
  prorrataActivityCount,
  setProrrataActivityCount,
}: {
  setValue: UseFormSetValue<DeclaracionModelo390DtoProps>
  watch: UseFormWatch<DeclaracionModelo390DtoProps>
  prorrataActivityCount: number
  setProrrataActivityCount: React.Dispatch<React.SetStateAction<number>>
}) => {
  const { t } = useTranslation()
  const values = watch()

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const fieldsProrrata: any[] = [
    {
      label: t("taxSummary.declaracion.prorrataModelo.box1"),
      code: "casilla114",
      inputNumber: "114",
    },
    {
      label: t("taxSummary.declaracion.prorrataModelo.box2"),
      code: "casilla115",
      inputNumber: "115",
    },
    {
      label: t("taxSummary.declaracion.prorrataModelo.box3"),
      code: "casilla116",
      inputNumber: "116",
    },
    {
      label: t("taxSummary.declaracion.prorrataModelo.box4"),
      code: "casilla117",
      inputNumber: "117",
    },
    {
      label: t("taxSummary.declaracion.prorrataModelo.box5"),
      code: "casilla118",
      inputNumber: "118",
    },
  ]

  const handleAddActivity = () => {
    if (prorrataActivityCount < 5) {
      setProrrataActivityCount((prev) => prev + 1)
    }
  }

  const visibleIndices = Array.from(
    { length: prorrataActivityCount },
    (_, i) => i + 1
  )

  return (
    <div className='tw-w-full tw-px-4 tw-pb-4 tw-space-y-3'>
      <ButtonERP
        label='Agregar actividad'
        customize={{ type: "primary", size: "md" }}
        onClick={handleAddActivity}
        disabled={prorrataActivityCount >= 5}
      />

      {visibleIndices.map((index) => (
        <ActivityTemplate
          key={`prorrata${index}`}
          text={`${index} - ${t("taxSummary.declaracion.prorrataModelo.box")}`}
          fields={fieldsProrrata}
          values={values}
          setValue={setValue}
          prefix={`prorrata${index}`}
        />
      ))}
    </div>
  )
}

export default Prorrata
